import { render, staticRenderFns } from "./PlaygroundKlessen.vue?vue&type=template&id=739bcc91&"
import script from "./PlaygroundKlessen.vue?vue&type=script&lang=js&"
export * from "./PlaygroundKlessen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports